import './styles/ProductInfoDisplay.scss';

import { Grid, Tooltip } from '@mui/material';

import { FunctionComponent, ReactNode } from 'react';

interface Props {
  label: string;
  tooltip?: string;
  children: ReactNode;
}

export const ProductInfoDisplay: FunctionComponent<Props> = props => {
  if (!!props.tooltip) {
    return (
      <Tooltip title={props.tooltip}>
        <Grid container className="contact-info-display">
          <Grid item xs={12} md={12} className="product-info-display__label">
            {props.label}:
          </Grid>
          <Grid item xs={12} md={12} className="product-info-display__value">
            {props.children}
          </Grid>
        </Grid>
      </Tooltip>
    );
  }
  return (
    <Grid container className="contact-info-display">
      <Grid item xs={12} md={12} className="product-info-display__label">
        {props.label}:
      </Grid>
      <Grid item xs={12} md={12} className="product-info-display__value">
        {props.children}
      </Grid>
    </Grid>
  );
};
